module.exports = __webpack_public_path__ + "img/personal-web06.7dbc31ca.png";